import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskList.html?raw';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import EvTaskEditor from './EvTaskEditor/EvTaskEditor';

class EvTaskList extends compose(_StatefulSection) {
    templateString: any = template;

    private btnReload: HTMLElement;
    private tableContainer: HTMLDivElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<EvTask>>>;

    private _rowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_task_description.description",
            "ref_vt_address_backoffice.gDisp_1",
            "date_forerun",
            "date_trailer"
        ],
        colNamesInternal: [
            "ref_task_description.description",
            "ref_vt_address_backoffice.gDisp_1",
            "date_forerun",
            "date_trailer"
        ],
        headings: [
            (this as any).translate("General_Label_EvTask"),
            (this as any).translate("General_Label_Employee"),
            (this as any).translate("EvTask_Label_DateForerun"),
            (this as any).translate("EvTask_Label_DateTrailer")
        ],
    }

    private _tableLayout: StaticTable.Layout = {
        label: "table",
        name: "table",
        rows: [(this as any)._rowConfig]
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<EvTask>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let value = cell.value;
        let node = cell.tableCellNode;

        switch (name) {

        }

        return false;
    }


    private _setupTable() {
        this.table = new StaticTable();
        this.table.setLayout(this._tableLayout);
        this.table.setFormatter(lang.hitch(this, this._tableFormatter));
        this.table.setupFromStore(this.store);
        this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEdit));
        this.table.addDefaultRowActionButton("delete");
        this.table.setRowClick(lang.hitch(this, this._onClickRow));
        this.table.placeAt(this.tableContainer);
        this.table.setCyAttribute("evTaskList");
    }

    private _onClickEdit(rowGroup: StaticTable.StaticTableRowGroup<EvTask>) {
        let entity = rowGroup.entity;
        this._openEditor(entity);
    }

    private _onClickRow(row: StaticTable.StaticTableRow<EvTask>) {
        let entity = row.rowGroup.entity;
        this._openEditor(entity);
    }

    private _onClickNew() {
        this._openEditor();
    }

    private _openEditor(entity?: EvTask) {
        let evTaskEditor = new EvTaskEditor();
        evTaskEditor.on("confirmed", lang.hitch(this, this._onEvTaskEditorConfirmed));
        let refEntity = this.getAttributeValue("___root");
        evTaskEditor.setup(entity, refEntity);
    }

    private _onEvTaskEditorConfirmed(entity: EvTask) {
        let isNew = entity.isNew;
        if (isNew) {
            this.store.addEntry(entity);
        } else {
            this.store.changeEntry(entity, true);
        }
    }

    private _onClickReload() {
        this.StandbyStart();
        let entityID = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let data = { bookingID: entityID, classname: classname };

        this.RequestManager.callfunction("Webtool_API__EvTask_GetEvTaskListData", data, lang.hitch(this, this._onReloadResponse), lang.hitch(this, this._onReloadError));
    }

    private _onReloadResponse(response: Array<EvTask>) {
        this.emit("reloaded");
        this.StandbyStop();
        this.store.setup(response);
    }

    private _onReloadError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onStoreChange(e) {
        let diffData = lang.clone(this.store.getDiffData());
        diffData.changed.forEach((t) => {
            if (t.date_forerun) t.date_forerun = this.dateToLocalISOString(t.date_forerun) as any;
            if (t.date_trailer) t.date_trailer = this.dateToLocalISOString(t.date_trailer) as any;
        });
        diffData.new.forEach((t) => {
            if (t.date_forerun) t.date_forerun = this.dateToLocalISOString(t.date_forerun) as any;
            if (t.date_trailer) t.date_trailer = this.dateToLocalISOString(t.date_trailer) as any;
        });
        this.setAttributeValue("evTaskDiffData", diffData);
    }

    hasData(): boolean {
        return this.store.getCurrentCompleteList().length > 0;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let data = this.getAttributeValue("evTasksV2");
        this.store.setup(data);

        this.hideNode(this.btnReload, !this.entityId);

    }



    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onStoreChange));

        this._setupTable();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskList);